import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from "@angular/core";
import { WidgetTitleComponent } from "../../../../shared/components/widget-title/widget-title.component";
import { SharedModule } from "../../../../shared/shared.module";
import { Widget } from "../../../dashboard/models/dashboard.model";
import { EntityMetadata } from "../../../../shared/store/store-types.model";
import { ArticleFacadeService } from "../../services/article/article-facade.service";
import { LotStockSummaryComponent } from "../../../lot/components/lot-stock-summary/lot-stock-summary.component";

@Component({
  selector: "vl-stock-kpis",
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    WidgetTitleComponent,
    LotStockSummaryComponent,
  ],
  host: { class: "widget-component" },
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./stocks-kpi.component.html",
})
export class StockKpisComponent {
  // Inputs
  widget = input<Widget>();
  metadata = input<EntityMetadata>();

  // Store
  private articleFacade = inject(ArticleFacadeService);
  stats = this.articleFacade.getState().stats;

  articleId = computed(() => {
    if (this.stats()) {
      return this.stats()?.lots?.[0]?.articleId;
    }
  });
}
